module.exports = __webpack_public_path__ + "static/media/calendar-3.21a9c723.svg";